export default __webpack_public_path__ + "static/markedwax-57b7497be2dcbee6465b96fbe6e7d3ad.png";